// Defined by the server contract
export const REQUEST_VERSION = 'NEWEQ3';
export const BRAND = 'COLES';

export enum WireProduct {
  Motor = 'Motor',
  Home = 'Home',
  Landlord = 'Landlord',
}

export enum WirePortfolio {
  Ktas = 'KTAS',
  Kmark = 'KMARK',
  ColesCp = 'COLES_CP',
}

export enum WireChannel {
  Web = 'Web',
  CC = 'CC',
}

export enum WireTransactionType {
  Quote = 'Quote',
  Policy = 'Policy',
  Endorsement = 'Endorsement',
  Renewal = 'Renewal',
  Cancellation = 'Cancellation',
}

export type WireFlybuys = {
  isSignUp: boolean;
  flybuysNumber?: string;
  latestConsent?: boolean;
  lockedConsent?: boolean;
};
